import {
    SHOW_ERROR_MESSAGE
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const fetchContractTypeSeller = (resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/sellers/contract-type")
        .then((response) => {          
            resolve(response.data);
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}

export const updateContractTypeSeller = (dto, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/sellers/contract-type", dto)
        .then((response) => {
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}


// WEBPACK FOOTER //
// ./src/reducers/seller/sellerActions.js